import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { Button, Box, Grid, Typography, CircularProgress, IconButton, Input, FormControlLabel, Checkbox, Card, CardContent } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import apiInstance from '../../../services/ServiceApi';

const Plantilla = ({linea_negocio}) => {
 
    const [files, setFiles] = useState([]);  
    const [fileInfo, setFileInfo] = useState(''); 
    const [severity, setSeverity] = useState('success');

    const [loading, setLoading] = useState(false);   
    const [openToast, setOpenToast] = useState(false);
    const [mensajeToast, setMensajeToast] = useState({})
    const hasFiles = files.length > 0;
    const hasTemplate = !!linea_negocio.plantilla_url;

    const clearFiles = () => {
        setFiles([]);
        setFileInfo('');
    };

    const onDrop = useCallback((acceptedFiles) => {
        setFiles(acceptedFiles); 
        let info = '';
        acceptedFiles.forEach((file) => {
            info += `Nombre: ${file.name}, Tamaño: ${file.size}, Tipo: ${file.type}\n`;
        });
        setFileInfo(info);
    }, []);

    const onUpload = () => {
    
          setLoading(true);
          files.forEach((file) => {
            const formData = new FormData();
            formData.append('plantilla',file);
      
            apiInstance
              .patch(`lineasnegocio/${linea_negocio.id}/`, formData)
              .then((response) => {
                console.log(response);
                setLoading(false);
                setOpenToast(true);
                setMensajeToast({ status: 'Carga de base completada' });
                setSeverity('success');
              })
              .catch((error) => {
                console.log(error);
                setLoading(false);
                setOpenToast(true);
                setMensajeToast(error);
                setSeverity('error');
              });
          });
      };
      
    const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop});

      return (
        <Grid container spacing={3} justifyContent="center" alignItems="center">
            <Grid item xs={12}>
                <Typography variant="h5" align="center" gutterBottom>
                    Plantilla del servicio {linea_negocio.linea_negocio}
                </Typography>
            </Grid>
            <Grid item xs={12} md={10}>
                <Card>
                    <CardContent>
                        <Grid container spacing={3}>
                            
                            <Grid item xs={12}>
                                <Box {...getRootProps()} sx={{
                                    height: 200,
                                    borderWidth: 2,
                                    borderColor: hasFiles ? 'primary.main' : 'grey.500',
                                    borderStyle: 'dashed',
                                    borderRadius: 2,
                                    p: 3,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    transition: 'border .3s ease-in-out'
                                }}>
                                    <input {...getInputProps()} />
                                    {hasTemplate ? (
                                        <>
                                            <CloudUploadIcon color="primary" style={{ fontSize: 40 }} />
                                            <Typography variant="body2" color="textSecondary">{linea_negocio.plantilla_url}</Typography>
                                        </>
                                    ) : (
                                        <>
                                            <CloudUploadIcon color="disabled" style={{ fontSize: 40 }} />
                                            {isDragActive ? 
                                                <p>Suelta los archivos aquí...</p> : 
                                                <p>Arrastra y suelta archivos aquí, o haz clic para seleccionar archivos</p>}
                                        </>
                                    )}
                                </Box>
                            </Grid>
                            <Grid item xs={12}>
                                <Box display="flex" justifyContent="center" gap={2}>
                                    {hasFiles && (
                                        <IconButton onClick={clearFiles} color="error">
                                            <DeleteIcon />
                                        </IconButton>
                                    )}
                                    <Button 
                                        variant="contained" 
                                        color="primary" 
                                        onClick={onUpload} 
                                        disabled={loading }
                                        startIcon={loading ? <CircularProgress size={24} /> : <CloudUploadIcon />}
                                    >
                                        {hasTemplate ? 'Cambiar Plantilla' : 'Cargar Plantilla'}
                                    </Button>
                                    {hasTemplate && (
                                        <Button 
                                            variant="outlined" 
                                            color="primary" 
                                            href={linea_negocio.plantilla_url}
                                            target="_blank"
                                            startIcon={<DownloadIcon />}
                                        >
                                            Descargar Plantilla
                                        </Button>
                                    )}
                                </Box>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    );
};

export default Plantilla;